import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, Table, TextField } from '../../../../../components';
import {
  Button,
  Container,
  Grid,
  Paper,
  Stack,
  Typography,
  TextField as MuiTextField,
  Box
} from '@mui/material';
import { useCallback, useEffect, useState } from 'react';
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import {
  dropdownFetch,
  formatDate,
  getCurrentDateTime,
  getISTDate,
  request,
  toast
} from '../../../../../utils';
import { useLocation } from 'react-router-dom';
import { CustomButtonn } from '../../../../../components';



const initialgrnDataObj = {
  data: [],
  loading: false
};

export const UpdateBatchRate = () => {
  const { pathname } = useLocation();
  const lastPathSegment = pathname.split('/').pop();
  const pathParts = pathname.split('/');
  const organisation = pathParts[1];
  const [loading, setLoading] = useState(false);
  const [currentAction, setCurrentAction] = useState();
  const [selectedRecord, setSelectedRecord] = useState();
  const [accountLedger,setAccountLedger] = useState([])
  const [grnDataObj,setGrnDataObj] = useState(initialgrnDataObj)
  const [productDetails,setProductDetails] = useState([])
  const user = JSON.parse(localStorage.getItem('user'));

  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({ })
    ),
    defaultValues: {
      date: getISTDate(),
      time: getCurrentDateTime('time'),
    },
    mode: 'all'
  });
  const { handleSubmit, watch, reset, setValue } = methods;

  const PRODUCT_HEADER = [
    {
      header: 'Product',
      accessor: (row) => {
        const name = row.product?.main?.name;
        const highrisk = row.product?.product_config?.highrisk === 'true';
        const refrigerated = row.product?.product_config?.refrigerated === 'true';
        const scheduleh1 = row.product?.product_config?.scheduleh1 === 'true';

        let color = 'black';

        if (highrisk) {
          color = 'red';
        } else if (refrigerated) {
          color = 'blue';
        } else if (scheduleh1) {
          color = 'orange';
        }

        return (
          <span style={{ color }}>
            {name}/{row?.product?.product_config?.generic_1?.generic_name}
          </span>
        );
      }
    }
  ];




  const getAccountLedgerData = useCallback(async () => {
    const data = await dropdownFetch('account-ledger');
    setAccountLedger(data);
  }, []);

  useEffect(() => {
    getAccountLedgerData();
  }, [getAccountLedgerData]);




  const formSubmit = async (formValues) => {
    setLoading(true);
    const payload = {
      ...formValues,
    };
    const response = await request('/update-batch-create', {
      method: 'POST',
      body: {
        ...payload,
        createdBy: user.name,
        organisation
      }
    });
    if (response?.success && response.data) {
      toast(`Successfully Updated Rate & Batch No `, { variant: 'success' });
      setSelectedRecord(response?.data);
      setCurrentAction();
      reset()
    } else {
      toast(`Failed to Update Rate & Batch`, { variant: 'error' });
    }
    setLoading(false);
  };


  const PRODUCT_TABLE_HEADER = [
    { header: 'GRN No.', accessor: 'cnt' },
    { header: 'GRN Date', accessor:(row)=> formatDate(row.grn_date) },
    { header: 'Supplier Name', accessor: (row) => row?.supplier.ledger_name}
  ];


  useEffect(()=>{
    GoodReceiptNoteList()
  },[])

  const watchGrnNo = watch('grn_no')
  const watchSupplier = watch('supplier');

    const GoodReceiptNoteList = async () => {
      setGrnDataObj({ loading: true });
       const query = {}
       query.limit = 50
       query.name = watchGrnNo
       query.supplier = watchSupplier
      const response = await request('/grn-list', { method: 'GET', query : query});
      if (response.success) {
        const filteredData = response.data.filter(
          (item) => item.status === 'active' || item.status === 'inactive' || item.status === 'default'
        );
        setGrnDataObj({ loading: false, data: filteredData });
      } else {
        toast('Error in fetching data', { variant: 'error' });
        setGrnDataObj({ loading: false });
      }
    };

function formatToMonthInput(dateString) {
  if (!dateString) return '';
  const date = new Date(dateString);
  // Ensure it's a valid date
  if (isNaN(date.getTime())) return '';
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  return `${year}-${month}`;
}

  return (
    <>
      <Paper
        sx={{
          p: 0,
          flex: 1,
          borderRadius: 0,
          boxShadow: 'none',
          width: '100%',
          height: 'auto'
        }}
      >
        <Container
          sx={{
            mt: 1,
            border: '0px solid',
            borderColor: 'grey.300',
            borderRadius: 1,
            width: '100%',
            maxWidth: 'none',
            minWidth: '100%',
            boxSizing: 'border-box'
          }}
        >
          <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
            <Stack
              direction="row"
              spacing={2}
              justifyContent="space-between"
              alignItems="center"
              sx={{
                mb: 1,
                borderBottom: '0px solid',
                borderColor: 'grey.300'
              }}
            >
              <Typography color="primary" variant="h3" sx={{ fontWeight: 600 }}>
                Update Batch & Rate
              </Typography>
              <Stack direction="row" justifyContent="flex-end" sx={{ mb: 3 }} spacing={1}>
                <CustomButtonn
                  id={'Submit'}
                  type="submit"
                  variant="contained"
                >
                  Update
                </CustomButtonn>
                <CustomButtonn
                  id={'Exit'}
                  variant="contained"
                  onClick={() => {
                    setCurrentAction('');
                  }}
                >
                  Exit
                </CustomButtonn>
              </Stack>
            </Stack>
            <Box
              sx={{
                border: '0px solid gray',
                padding: 2,
                borderRadius: '8px',
                width: '100%',
                boxShadow: '0px 2px 10px #0099ff'
              }}
            >
              <Grid container spacing={1}>
                <Grid item xs={8} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Stack spacing={0.5} direction="row" alignItems="center">
                    <Typography sx={{ flex: 0.15, fontWeight: 700, fontSize: '1.4rem' }}>GRN No.</Typography>
                    <TextField sx={{ flex: 0.5 }} name="grn_no" placeholder="GRN No." />
                    <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Supplier Name</Typography>
                    <SelectTag
                      formControlSX={{ flex: 0.5 }}
                      name="supplier"
                      menus={accountLedger.map((data) => ({
                        ...data,
                        name: data.ledger_name
                      }))}
                    />
                    <Button variant="contained" onClick={GoodReceiptNoteList}>Search</Button>
                  </Stack>
                  <Table
                    containerSX={{ flex: 1, border: '0px solid rgba(0,0,0,0.27)', boxShadow: '0px 2px 2px #0099ff',minHeight:'150px'}}
                    data={grnDataObj.data || [] }
                    columns={PRODUCT_TABLE_HEADER}
                    size="small"
                    onRowClick={(row)=>{
                       setProductDetails(row.add_details)
                       setValue('grn_no',row.cnt)
                    }}
                  />
                  <Stack
                    sx={{
                      border: '1px solid grey',
                      padding: '5px',
                      borderRadius: '5px',
                      boxShadow: '0px 2px 2px #0099ff'
                    }}
                    spacing={0.5}
                    direction="column"
                  >
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>GRN No</Typography>
                      <TextField
                        disabled
                        sx={{ flex: 1 }}
                        name="grn_no"
                        placeholder="GRN No."
                      />
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Selected Product</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 1 }}
                        name="product_name"
                        placeholder="Selected Product"
                      />
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Batch No</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="batch_no"
                      />
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New Batch No.</Typography>
                      <TextField  sx={{ flex: 0.4 }} name="new_batch_no" placeholder="New Batch No" />
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Exp Date</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="exp_date"
                        type="month"
                      />
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New Exp Date</Typography>
                      <TextField  sx={{ flex: 0.4 }} name="new_exp_date" placeholder="Inv No." type="month" />
                    </Stack>
                      <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Rate</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="rate"
                      />
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New Rate</Typography>
                      <TextField sx={{ flex: 0.4 }} name="new_rate" placeholder="New Rate"/>
                    </Stack>
                         <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Sale Rate</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="sale_rate"
                      />
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New Sale Rate</Typography>
                      <TextField  sx={{ flex: 0.4 }} name="new_sale_rate" placeholder="New Sale Rate"/>
                    </Stack>
                                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Conversion</Typography>
                      <TextField
                        disabled={!['new', 'edit'].includes(currentAction)}
                        sx={{ flex: 0.4 }}
                        name="conversion"
                      />
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>New Conversion</Typography>
                      <TextField  sx={{ flex: 0.4 }} name="new_conversion" placeholder="New Conversion" />
                    </Stack>
                    <Stack direction="row" alignItems="center" spacing={0.5}>
                      <Typography sx={{ flex: 0.2, fontWeight: 700, fontSize: '1.4rem' }}>Remarks</Typography>
                      <TextField
                        sx={{ flex: 1 }}
                        name="remarks"
                      />
                    </Stack>
                  </Stack>
                  <Stack direction="row" spacing={0.5} alignItems="center" marginTop={'4%'}></Stack>
                </Grid>
                      <Grid item xs={4} sx={{ display: 'flex', flexDirection: 'column' }}>
                  <Grid item sx={{ display: 'flex', flexDirection: 'column', marginTop: '1%' }}>
                    <Stack direction="row" alignItems="center" justifyContent="center">
                    </Stack>
                    <Table
                      containerSX={{
                        flex: 1,
                        maxHeight: '400px'
                      }}
                      data={productDetails || []}
                      columns={PRODUCT_HEADER}
                      onRowClick={(row)=>{
                        console.log(row,"HELLO ROW IS HERE..")
                        setValue('product',row?.product?._id);
                        setValue('product_name',row?.product?.main?.name)
                        setValue('batch_no',row?.batch_no)
                        setValue('exp_date',formatToMonthInput(row?.exp_date))
                        setValue('rate',row?.rate)
                        setValue('sale_rate',row?.sal_rate)
                        setValue('conversion',row?.conversion)
                      }}
                      size="small"
                      sx={{
                        '& .MuiTableCell-root': {
                          fontSize: '1.4rem',
                          padding: '3px'
                        },
                        '& .MuiTableCell-head': {
                          fontSize: '1.4rem',
                          fontWeight: 'bold'
                        },
                        '& .MuiTableRow-root': {}
                      }}
                    />
                  </Grid>
                </Grid>
              </Grid>
            </Box>
          </FormProvider>
        </Container>
      </Paper>
    </>
  );
};
